import { LoadingOutlined, LockOutlined, MailOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, Row, Space, Spin, Typography } from 'antd'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import MyAccountStyle from '../../styles/MyAccount.module.css'
import { UserContext } from '../context'
import { useApiData } from '../context/apiContext'
import { verifyLogin } from '../services'
import { checkSelfService } from '../services/Api'
import { getDomain } from '../utils'
import { HeaderHero, QSLogin, SEO } from './components'
import DownloadMobileAppCard from './DownloadMobileAppCard/DownloadMobileAppCard'
import YendoCard from './YendoCard/YendoCard'

const LOGIN_ERROR = 'Invalid email address or password.'
const PASSKEY_LOGIN_ERROR = 'Passkey Signing failed.'
const WRONG_PASSWORD_ERROR = 'Incorrect password. Please try again.'
const antIcon = <LoadingOutlined spin style={{ fontSize: 24 }} />

const tabletImage = 'hero/my-account/My-Account_1024x300-no-copy.jpg'
const desktopImage = 'hero/my-account/My-Account_1440x300-no-copy.jpg'
const largeScreenImage = 'hero/my-account/My-Account_1620x300-no-copy.jpg'
const xtraLargeScreenImage = 'hero/my-account/My-Account_1960x300-no-copy.jpg'
const smallImage = 'hero/my-account/My-Account_375x188.jpg'
const smallImage390 = 'hero/my-account/My-Account_390x188.jpg'
const mobileImage = 'hero/my-account/My-Account_428x188.jpg'
const mobileImage768 = 'hero/my-account/My-Account_768x300-no-copy.jpg'

const { Text, Title, Link } = Typography

const MyAccount = () => {
  const router = useRouter();
  const [showQuickServiceSection, setShowQuickServicePage] = useState(false)
  const [selectedQS, setSelectdeQS] = useState('')
  const [showSpinner, setShowSpinner] = useState(false)
  const [qsApiResponseMessage, setQSApiResponseMessage] = useState()
  const [showSpinnerQS, setShowSpinnerQS] = useState(false)
  const [, dispatch] = useContext(UserContext)
  const [emailAddress, setEmailAddress] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMeCheck, setRememberMeCheck] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loginMessage, setLoginMessage] = useState('')
  const [websiteMaintenanceMessage, setWebsiteMaintenanceMessage] = useState(null)
  const [websiteMaintenanceStatus, setWebsiteMaintenanceStatus] = useState(false)
  const { apiData1, apiData2 } = useApiData();
  const [isClient, setIsClient] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (localStorage.getItem('loginCredentials')) {
      var credentials = JSON.parse(localStorage.getItem('loginCredentials'))
      var email = credentials.emailAddress
      setEmailAddress(email)
      setRememberMeCheck(credentials.rememberMe)
    }

    const params = new URLSearchParams(window.location.search)
    const prefill = params.get('prefill')
    if (prefill) {
      setShowPassword(true)
      const pass = params.get('pass')
      if (pass) {
        setPassword(atob(pass))
      }
    }
  }, [])

  useEffect(() => {
    if (apiData1 && apiData2) {
      function fetchWebsiteMaintainence() {
        var websiteStatusResponse = apiData1
        var websiteMessageResponse = apiData2

        const status = websiteStatusResponse?.data;
        if (status?.Result == "Active" && status?.Pages.includes("MyAccountLogin")) {
          setWebsiteMaintenanceStatus(!status.AllowAccessPages.includes("MyAccountLogin"));
          setWebsiteMaintenanceMessage(websiteMessageResponse?.data?.Result);
        } else {
          setWebsiteMaintenanceStatus(false);
          setWebsiteMaintenanceMessage(null);
        }
      }
      fetchWebsiteMaintainence()
    }
  }, [apiData1, apiData2]);

  const qsClass = showQuickServiceSection ? 'show-quick-service' : 'hide-quick-service'
  const qsSectClass = showQuickServiceSection ? 'hide-qs-service' : 'show-qs-service'
  const nonQsClass = showQuickServiceSection ? 'hide-non-qs-service' : 'show-non-qs-service'

  const scrollToRef = () => {
    const ref = document.querySelectorAll('[class*="my-account-screen"]'); //getElementsByClassName('my-account-screen')
    if (ref && ref.length > 0) {
      window.scrollTo(0, ref[0].offsetTop)
    }
  }
  const executeScroll = () => scrollToRef()

  const closeQSModal = () => {
    setShowQuickServicePage(false)
    setSelectdeQS('')
    setQSApiResponseMessage(null)
  }


  const handleLogin = async (emailAddress, password, challengeID = null) => {
    setShowSpinner(true)
    const response = await verifyLogin(emailAddress, password, 'login', challengeID)
    if (response && response.data) {
      const { Result, Tkn, Zip, PolicyNumber, Env } = response.data

      if (Result === 'Not Found') {
        setErrorMessage(challengeID == null ? LOGIN_ERROR : PASSKEY_LOGIN_ERROR)
        setLoginMessage('')
      } else if (Result === 'Error') {
        setErrorMessage(LOGIN_ERROR)
        setLoginMessage('')
      } else if (Result === "Non Converted GW User") {
        router.push(`/my-account/update?verifiedUser=${emailAddress}`)
      } else if (Result === "Policy User and Non Converted GW User") {
        router.push('/my-account/forgot-email')
      } else if (Result === 'Incorrect Password') {
        setErrorMessage(WRONG_PASSWORD_ERROR)
        setLoginMessage('')
      } else if (Result === 'Unable to locate policy.') {
        setErrorMessage(Result)
        setLoginMessage('')
      } else {
        setLoginMessage(Result)
        setErrorMessage('')
      }

      if (Result === 'Success') {
        // Check self service table if policy is blocked from logging in
        const selfServiceResponse = await checkSelfService(PolicyNumber, Env)
        if (selfServiceResponse?.data?.Result != null) {
          setErrorMessage(selfServiceResponse?.data?.Result)
          setLoginMessage('')
          setShowSpinner(false)
        }
        else {
          const url = `https://${getDomain('account')}/home?tkn=${Tkn}`
          window.location = url
        }
      } else if (Result === 'Loaded By Temp Password') {
        dispatch({
          type: 'ADD_EMAIL',
          payload: {
            emailAddress,
            tempPassword: password
          }
        })
        router.push({
          pathname: '/my-account/temp-password',
          query: { Result, Zip, PolicyNumber }
        })
        // window.location = '/my-account/temp-password'
      } else {
        setShowSpinner(false)
      }
    } else {
      setShowSpinner(false)
    }
  }

  const handleQSLogin = async (ssnNumber, zipCode) => {
    setQSApiResponseMessage(null)
    setShowSpinnerQS(true)
    const response = await verifyLogin(zipCode, ssnNumber, 'qs')
    if (response && response.data) {
      const { Result, Tkn, Zip, PolicyNumber, Env } = response.data
      setQSApiResponseMessage(Result)
      if (Result === 'Success') {
        const url = `https://${getDomain('account')}/quick-service?tkn=${Tkn}`
        window.location = url
      } else {
        setShowSpinnerQS(false)
      }
    } else {
      setShowSpinnerQS(false)
    }
  }

  const handleClick = () => {
    setLoginMessage('')
    setErrorMessage('')
    setShowSpinner(true)

    // Stores credentials if remember is checked
    if (rememberMeCheck) {
      localStorage.setItem('loginCredentials', JSON.stringify({ emailAddress: emailAddress, rememberMe: rememberMeCheck }))
    }
    else {
      localStorage.removeItem('loginCredentials')
    }
    handleLogin(emailAddress, password)
  }

  // const passkeyLogin = async () => {
  //   var loginOpts = await initLoginOptions();
  //   if (!loginOpts || loginOpts.status !== 200) {
  //       throw new Error("Failed to get login options");
  //   }
  //   // console.log(loginOpts);
  //   const { options, challengeId } = loginOpts.data;
  //   const assertionResponse = await startAuthentication(options);
  //   const result = await LoginVerify({assertionResponse: assertionResponse, challengeID: challengeId});
  //   if (!result || result.status !== 200) {
  //     setErrorMessage("Failed to Login using Passkey")
  //     setLoginMessage('')
  //   } else {
  //       setErrorMessage("")
  //       handleLogin(result.data.email,"",challengeId);
  //   }
  // }

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleClick()
    }
  }
  return (
    <>
      <SEO
        description="Access your CURE Auto Insurance account to easily make a payment, get your ID cards, change your address, add and remove vehicles, drivers and more."
        title="My Account Login Page for NJ, PA & MI Drivers | CURE"
        url="/my-account"
      />
      <div className={`${MyAccountStyle["my-account"]}`}>
        <HeaderHero
          desktopImage={desktopImage}
          largeScreenImage={largeScreenImage}
          mobileImage={mobileImage}
          mobileImage768={mobileImage768}
          smallImage={smallImage}
          smallImage390={smallImage390}
          tabletImage={tabletImage}
          title="MY ACCOUNT"
          xtraLargeScreenImage={xtraLargeScreenImage}
          alt={"My Account - CURE auto insurance"}
          className='object-fit-unset'
        />
        <Row className={`${MyAccountStyle["my-account-screen"]} page-text-margin`}>
          {/* Login */}
          <Col span={24} lg={{ span: 12, order: 1 }} order={1} className={`${nonQsClass}`}>
            <Card bordered={false} >
              <Title className={`${MyAccountStyle["my-account-sub-title"]} ${MyAccountStyle["text-center"]}`} level={2}>
                Log In
              </Title>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Col span={0} lg={24}>
                <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["text-center"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["margin-left-below-login"]}`}>
                  Log in to access your policy information 24/7.
                </Text>
              </Col>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Card bordered={false} className={`${MyAccountStyle["login-class"]}`} title={''}>
                {isClient && <>
                  <Form>
                    <Form.Item>
                      <Input autoComplete="off" className={`${MyAccountStyle["input-text"]}`} disabled={websiteMaintenanceStatus} onChange={(event) => setEmailAddress(event.target.value)} onKeyDown={handleKeyDown} placeholder='Username or Email Address' prefix={<MailOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />} value={emailAddress} />
                    </Form.Item>
                    <Form.Item>
                      <Input.Password autoComplete="off" className={`${MyAccountStyle["input-text"]}`}
                        disabled={websiteMaintenanceStatus}
                        iconRender={visible => (visible ? 'Hide' : 'Show')}
                        onChange={(event) => setPassword(event.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder='Password'
                        prefix={<LockOutlined className={`${MyAccountStyle["site-form-item-icon"]}`} />}
                        visibilityToggle={{ visible: showPassword, onVisibleChange: setShowPassword }}
                        type="password"
                        value={password}
                      />
                      {errorMessage && <div className={`${MyAccountStyle["error-message"]}`}>
                        {
                          errorMessage
                        }
                      </div>}
                      {loginMessage === 'Inactive' && <div className={`${MyAccountStyle["error-message"]}`}>
                        Your policy is inactive. Please call 800-535-2873 for assistance.
                      </div>}
                      {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <div className={`${MyAccountStyle["blue-message"]} ${MyAccountStyle["float-left"]}`}>Please wait ...</div>}
                      {loginMessage !== 'Inactive' && errorMessage !== 'Invalid email address or password.' && showSpinner && <Spin indicator={antIcon} />}
                    </Form.Item>

                    {/* Remember Me */}
                    <Row style={{ marginTop: '-2em', height: '50px', justifyContent: 'center', alignContent: 'center' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <input type='checkbox' id='rememberMeCheck1' style={{ alignContent: 'center' }} checked={rememberMeCheck} onChange={(e) => setRememberMeCheck(e.currentTarget.checked)} />
                        <label htmlFor='rememberMeCheck1' style={{ fontSize: '16px', clear: 'both' }}>&nbsp;&nbsp;Remember Me</label>
                      </div>
                    </Row>

                    {!websiteMaintenanceStatus && <Row className={`${MyAccountStyle["forgot-links"]}`}>
                      <a className={`${MyAccountStyle["forgot-text"]}`}>Forgot</a>
                      <Link href='/my-account/forgot-email' style={{ marginRight: 3 }}> Username / Email Address</Link>
                      <a className={`${MyAccountStyle["forgot-text"]}`}>or</a>
                      <Link href='/my-account/forgot-password' style={{ marginRight: 3 }}>Password?</Link>
                    </Row>}
                    <Form.Item className={`${MyAccountStyle["btn-control"]}`}>
                      <Space>
                        {/* <Button className={`${MyAccountStyle["login"]} ${MyAccountStyle["login-form-button"]}`} disabled={websiteMaintenanceStatus} onClick={passkeyLogin}>
                          Passkey Signin
                        </Button> */}
                        <Button className={`${MyAccountStyle["login"]} ${MyAccountStyle["login-form-button"]}`} disabled={websiteMaintenanceStatus} onClick={handleClick}>
                          Log In
                        </Button>
                      </Space>
                    </Form.Item>
                  </Form>
                </>}
              </Card>
              <Row className={`${MyAccountStyle["forgot-links"]} ${MyAccountStyle["create-account-container"]}`}>
                <a className={`${MyAccountStyle["forgot-text"]}`}>New user? </a>
                <Link href='/my-account/register' className={`${MyAccountStyle["account-link"]}`} style={{ marginRight: 3 }}>Create an account!</Link>
              </Row>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["subtext"]} ${MyAccountStyle["text-center"]}`}>
                Enroll in Autopay and paperless billing so you never miss a payment.
              </Text>
            </Card>
          </Col>
          {/* Mobile Ad Card */}
          <Col span={24} lg={{ span: 12, order: 2 }} order={2} className={`${nonQsClass}`}>
            <DownloadMobileAppCard />
          </Col>
          {/* QS */}
          <Col span={24} lg={{ span: 12, order: 3 }} order={4} >
            <Card bordered={false} className={`${qsSectClass} ${MyAccountStyle['bg-color-blue']}`} >
              <Title className={`${MyAccountStyle["my-account-sub-title-qs"]} ${MyAccountStyle["text-center"]}`} level={2}>
                Or, skip logging in...
              </Title>
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-12"]}`} />
              <Text className={`${MyAccountStyle["sub-title"]} ${MyAccountStyle["margin-left-26"]} ${MyAccountStyle["height-1"]} `} />
              <Row>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  span={24}
                >
                  {isClient && <>
                    <a
                      href={'https://' + getDomain('payments')}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Button className={`${MyAccountStyle["manage-policy"]} ${MyAccountStyle["text-left"]}`}>
                        <img alt="manage_policy" /> PAY BILL NOW
                      </Button>
                    </a>
                  </>}
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  span={24}
                >
                  {isClient && <a
                    onClick={() => {
                      setSelectdeQS('Get your ID card.')
                      setShowQuickServicePage(true)
                    }}
                  >
                    <Button className={`${MyAccountStyle["get-id-card"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="get_id_card" /> GET ID CARD
                    </Button>
                  </a>}
                </Col>
                <Col
                  className={`${MyAccountStyle["account-button"]}`}
                  span={24}
                >
                  {isClient && <a
                    onClick={() => {
                      setSelectdeQS('View your amount due.')
                      setShowQuickServicePage(true)
                    }}
                  >
                    <Button className={`${MyAccountStyle["make-payment"]} ${MyAccountStyle["text-left"]}`}>
                      <img alt="make_payment" /> VIEW AMOUNT DUE
                    </Button>
                  </a>}
                </Col>
              </Row>
            </Card>

            {/* Login/QS form */}
            <Col
              className={`${MyAccountStyle["margin-auto"]}`}
              style={{ width: '90%' }}
              span={24}
            >
              {isClient && <>
                <QSLogin
                  closeQSModal={closeQSModal}
                  handleSubmit={handleQSLogin}
                  message={qsApiResponseMessage}
                  quickServiceClass={qsClass}
                  selectedQS={selectedQS}
                  setShowSpinner={setShowSpinnerQS}
                  showSpinner={showSpinnerQS}
                />
              </>}
            </Col>
          </Col>
          {/* Yendo Card */}
          <Col span={24} lg={{ span: 12, order: 4 }} order={3} className={`${nonQsClass}`}>
            <YendoCard />
          </Col>
        </Row>
      </div>
    </>
  )
}

MyAccount.propTypes = {}

export default MyAccount
